import { SkeletonStyled } from "./Skeleton.styled";

function Skeleton() {
    return <SkeletonStyled />;
}

export default Skeleton;
